/**
 * Toolbar tool id vocabulary, shared by `MetaspaceToolbar` and
 * `useToolbarUrlState` — split out so the URL-state hook doesn't have to pull
 * in the toolbar component (PrimeReact, Redux, ArmillaryActions modes, ...)
 * just to resolve an id.
 */

export type ToolbarItem = 'stream' | 'notifications' | 'tasks' | 'status' | 'chatbox' | 'trajectory';

// EAINT-856: Activity -> Stream, Timeline -> Trajectory. Stored metaspace
// settings (`toolbarDefaultActiveItem`, `enabledToolbarItems`,
// `disabledToolbarItems`) are migrated forward by
// `20260827000000_rewrite_toolbar_tool_ids.js`, but this alias map keeps any
// unmigrated payload (or a bookmarked `?tool=` URL) from losing a toolbar
// item — see specs/stream-trajectory-tools.md § SC11.
const LEGACY_TOOLBAR_ITEM_ALIASES: Record<string, ToolbarItem> = {
  activity: 'stream',
  timeline: 'trajectory',
};

export function resolveToolbarItemAlias(id: string): ToolbarItem {
  return (LEGACY_TOOLBAR_ITEM_ALIASES[id] ?? id) as ToolbarItem;
}

export function resolveToolbarItemAliasList(ids: string[]): ToolbarItem[] {
  return ids.map(resolveToolbarItemAlias);
}
